import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FlagRenderer } from '@/components/FlagRenderer/FlagRenderer'
import { Modal } from '@/components/Modal'
import { useCzListSetsContext } from '@/contexts/cz-list-sets/useCzListSetsContext'
import { CountWithDetailsButton } from './CountWithDetailsButton'
import './distribution-customs-zones.scss'

export function DistributionCustomsZones({
  selectedCustomsZones,
}: Readonly<{
  selectedCustomsZones?: string[]
}>) {
  const { t } = useTranslation()
  const { czListSetsByCustomZone } = useCzListSetsContext()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const getZoneLabel = (id: string) => {
    const designation = czListSetsByCustomZone[id]?.designation
    return designation?.trim()
      ? designation.replace(/^CZ\s+/, '')
      : t('products-page.product-card.unknown-customs-zone', { id })
  }

  const zones = [
    ...new Set((selectedCustomsZones ?? [])
      .map(zone => zone.trim())
      .filter(Boolean)
      .sort((a, b) => getZoneLabel(a).localeCompare(getZoneLabel(b)))),
  ]

  return (
    <div className="product-distribution-customs-zones" data-testid="distribution-customs-zones">
      <span className="product-distribution-customs-zones__labels">
        {t('products-page.product-card.distribution-customs-zones')}
      </span>
      {zones.length === 0
        ? t('products-page.product-card.no-data')
        : (
            <CountWithDetailsButton
              ariaLabel={t('aria-label.open-distribution-customs-zones-modal')}
              dataTestid="distribution-customs-zones_eye-icon"
              onOpenDetails={() => setIsModalOpen(true)}
            >
              {t('products-page.product-card.distribution-customs-zones-count', { count: zones.length })}
            </CountWithDetailsButton>
          )}
      <Modal
        dataTestid="distribution-customs-zones-modal"
        isOpen={isModalOpen}
        title={t('products-page.product-card.distribution-customs-zones-modal-title')}
        width="40vw"
        validationAction={() => setIsModalOpen(false)}
        onClose={() => setIsModalOpen(false)}
      >
        <ul className="distribution-customs-zones-modal-list">
          {zones.map(id => (
            <li key={id}>
              <FlagRenderer countryCode={czListSetsByCustomZone[id]?.reference?.slice(0, 2) ?? ''} />
              {getZoneLabel(id)}
            </li>
          ))}
        </ul>
      </Modal>
    </div>
  )
}
